import 'jquery-pjax/jquery.pjax.js';

/**
 * PJAX
 */
function $pjaxify () {

    // $(document).pjax('a', '#main', { fragment: '#main' });
}

export default $pjaxify;


// WEBPACK FOOTER //
// ./src/js/app/components/pjax.js